module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABDUlEQVRYR+3WMW7CQBCF4X8cKTkAQkpJlSak5gZ0yKTkEmkiXwLlClSp4gKo6BDcg4qSK1BkI4MiKGzW1lraEZqtPetPb2ZXKyhfotyHAUM7ZAlagqEJhNbbDFqCjRNYuS5HfhAG/PLBu8wa73FV0O4M5q7LIxuE19M/HHvG0tMBPOPWCG9XoAOpPMcHluMKlwJgNU4B8DYuMtCPiwicuw4JW4S+5wBEmsGlmyJkNU5nJODCfZLwpReYuwee+AYmOltcqOohI7X4PzY/MjLQn6QC4G2kEmA1UhGwHLkjlZca11HlJ+2+By/I4o4ckpAxkpUuYIimpLb9BA3YcgKh21mLLcHQBELrbQbvPsE/j2tLKQgwxjUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/left-arrow.png
// module id = fnJD
// module chunks = 2